module.exports = __webpack_public_path__ + "static/media/vi.3482e749.svg";